import {graphql} from 'react-apollo';
import {addToTripboardMutation} from '../../graphql';
import edap from '../../utils/edap';
import TripBoard from '../TripBoard/TripBoard';
import {readPreviewsCache, writePreviewsCache} from './with-fetch-previews';

export const addListingToCache = (hav, pageSize, listingPageSize, listingId, boardId, thumbnailUrl) => {
    return (proxy) => {
        const cache = readPreviewsCache(proxy, hav, pageSize, listingPageSize);
        if (!cache || !cache.paginatedTripBoards) {
            return; // why bother, we aren't getting fed tripboard previews
        }

        const boards = cache.paginatedTripBoards.tripBoards || [];
        const thisTripBoardIndex = boards.findIndex(({uuid}) => uuid === boardId);
        if (thisTripBoardIndex >= 0) {
            const thisTripBoard = boards[thisTripBoardIndex];
            thisTripBoard.listingRefs = [listingId, ...thisTripBoard.listingRefs];
            thisTripBoard.listings = [
                {
                    __typename: 'Listing',
                    listingId,
                    images: [{__typename: 'Image', c6_uri: thumbnailUrl, width: 800, height: 600}]
                },
                ...thisTripBoard.listings
            ];
            writePreviewsCache(proxy, hav, pageSize, listingPageSize, cache);
        }
    };
};

export const handleOnMutationComplete = (listingId) => (data) => {
    const createTripBoard = (data && data.createTripBoard) || {};
    const {uuid, stay} = createTripBoard;
    const {adultCount, childrenCount, petsIncluded} = stay || {};
    const {arrival, departure} = (stay && stay.dateRange) || {};
    edap.boardSaved(false, adultCount, childrenCount, petsIncluded, arrival, departure, listingId, uuid);
};

export const handleOnMutationError = (listingId, boardId) => () => {
    TripBoard.showCreateError(listingId);
    edap.boardCreateError(listingId, boardId);
};

export const optimisticAddToTripBoardResponse = {
    addUnitToTripBoard: true
};

const withAddToTripBoard = graphql(addToTripboardMutation, {
    options: ({mutationConfig, listingId}) => ({
        ...mutationConfig,
        onCompleted: handleOnMutationComplete(listingId),
        optimisticResponse: optimisticAddToTripBoardResponse
    }),
    name: 'addToTripBoard',
    alias: 'withAddToTripBoardMutation'
});

export default withAddToTripBoard;
